<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2024 (original work) Open Assessment Technologies SA ;
    import { __ } from '@oat-sa-private/ui-core';

    export let currentPage = null;
    export let totalPages = null;

    let selectElement;
    let focusWrapper;

    function handleSelectClick() {
        focusWrapper.classList.add('select-clicked');
    }

    function handleSelectBlur() {
        focusWrapper.classList.remove('select-clicked');
    }
</script>

<style>
    .focus-visible-wrapper {
        height: 100%;
        width: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        &:not(.select-clicked):focus-within {
            &::before {
                content: '';
                position: absolute;
                display: block;
                height: 6.5rem;
                width: 6.5rem;
                left: -0.5rem;
                top: -0.5rem;
                border-radius: var(--radius-circular);
                border: var(--border-medium) dotted var(--color-border-default);
            }
        }

        & .page-select {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 0;
            /* hiding the real select text */
            font-size: 0;
            appearance: none;
            -webkit-appearance: none;
            background: none;
            overflow-x: visible;
            border: var(--border-medium) solid var(--color-border-default);
            height: 100%;
            width: 100%;
            border-radius: var(--radius-circular);
            position: relative;
            cursor: pointer;

            &:hover {
                background-color: var(--color-gs-light-hover-bg);
            }

            & option {
                /* unhide option labels */
                font-size: var(--fontsize-body);
            }
        }

        & :global(.page-select) {
            @add-mixin outline-focus 0;
        }

        & .page-label {
            @add-mixin bold;
            color: var(--color-text-default);
            font-size: var(--fontsize-body);
            position: absolute;
            z-index: var(--layer-1);
            pointer-events: none;
        }
    }
</style>

<!-- in Safari it's impossible to center the text in <select> by css text-align
so the div with page number is created which covers the native select -->
<div class="focus-visible-wrapper" bind:this={focusWrapper}>
    <div class="page-label">{currentPage}</div>
    <select
        class="page-select"
        on:change
        on:blur={handleSelectBlur}
        on:click={handleSelectClick}
        value={currentPage}
        bind:this={selectElement}>
        {#each [...Array(totalPages).keys()] as page}
            <option value={page + 1}>{`${__('Page')} ${page + 1}`}</option>
        {/each}
    </select>
</div>
